// extracted by mini-css-extract-plugin
export default {"action":"CardholdersTable_action__ptOaA","labelWrap":"CardholdersTable_labelWrap__qzVxq"};